import React from 'react';
import { FacilityAdditionalContactBulkCreateTemplate } from 'themes/application/facility/components';
import { observer } from 'mobx-react';
import { FacilityAdditionalContactBulkCreateViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';
@setCurrentView((rootStore, componentProps) => new FacilityAdditionalContactBulkCreateViewStore(rootStore, componentProps), 'facilityAdditionalContactBulkCreateView')
@observer
class FacilityAdditionalContactBulkCreate extends React.Component {
    render() {
        return <FacilityAdditionalContactBulkCreateTemplate {...this.props} />
    }
}

export default FacilityAdditionalContactBulkCreate;